// blogfilter.js
// Handles tab-based filtering of blog posts by category

document.addEventListener('DOMContentLoaded', function () {
    const tabContainer = document.querySelector('.blog-category-tabs');
    if (!tabContainer) return;

    const tabs = tabContainer.querySelectorAll('.blog-category-tab');
    const postListContainer = document.querySelector('.col--post-list');

    // Delegate for pagination links
    function handlePaginationClick(e) {
        const link = e.target.closest('.nav-links a');
        if (link) {
            e.preventDefault();
            // Refined regex to handle /page/2 or ?paged=2
            const pagedMatch = link.href.match(/page\/(\d+)/) || link.href.match(/paged=(\d+)/);
            const paged = pagedMatch ? pagedMatch[1] : 1;
            const activeTab = tabContainer.querySelector('.blog-category-tab.active');
            const category = activeTab ? activeTab.getAttribute('data-category') : 'all';
            fetchPosts(category, paged);
        }
    }

    // Fetch posts via AJAX
    function fetchPosts(category, paged = 1) {
        postListContainer.classList.add('loading');

        // Update the URL bar so the "Back" button works && so that on refresh it doesn't kick them back to the homepage
        const newUrl = paged > 1 ? `/education-center/page/${paged}/` : `/education-center/`;
        window.history.pushState({ category, paged }, '', newUrl);

        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `action=blog_filter&category=${encodeURIComponent(category)}&paged=${paged}`
        })
            .then(res => res.json())
            .then(data => {
                if (data.success && data.data && data.data.html) {
                    postListContainer.innerHTML = data.data.html;
                    // Scroll back to top of list so user sees new content
                    postListContainer.scrollIntoView({ behavior: 'smooth' });
                }
            })
            .finally(() => {
                postListContainer.classList.remove('loading');
            });
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            fetchPosts(tab.getAttribute('data-category'), 1);
        });
    });

    // Delegate pagination clicks
    postListContainer.addEventListener('click', handlePaginationClick);
});
